var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.75,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10938 5.11719L18.8672 18.8672",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 17.7143V17.7143C8.01035 18.4189 8.74947 18.8571 9.55259 18.8571H12C13.6667 18.8571 17 18.1714 17 15.4286C17 14.2857 16 12 12 12C10.3333 12 7 11.3143 7 8.57143C7 7.42857 8 5.14286 12 5.14286H14.4474C15.2505 5.14286 15.9897 5.58108 16.375 6.28571V6.28571M12 20V4",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProfit);
export default __webpack_public_path__ + "static/media/NonProfit.2d1aa3989e0e4e03fc532a045d3948e1.svg";
export { ForwardRef as ReactComponent };